import React, { useState, useEffect } from "react";
import toastr from "toastr";
import { authFetch } from "../utils/authFetch";

function Permission() {
  const [permissionForm, setPermissionForm] = useState({
    name: "",
    slug: "",
    type: "",
  });
  const [permissions, setPermissions] = useState([]);
  const [editingId, setEditingId] = useState(null);
  const [loading, setLoading] = useState(false);

  const fetchPermissions = async () => {
    try {
      const res = await authFetch("/api/v1/permission/list", {
        // headers: {
        //   Authorization: `Bearer ${localStorage.getItem("token")}`,
        // },
      });
      const data = await res.json();
      setPermissions(Array.isArray(data) ? data : []);
    } catch {
      showToast("Failed to fetch permissions", "error");
    }
  };

  useEffect(() => {
    fetchPermissions();
  }, []);

  const showToast = (message, type = "success") => {
    toastr.options = {
      closeButton: true,
      progressBar: true,
      positionClass: "toast-top-right",
      timeOut: "3000",
    };
    toastr[type](message);
  };

  const handleCreateOrUpdate = async () => {
    if (!permissionForm.name.trim() || !permissionForm.slug.trim()) {
      showToast("Name and Slug are required", "error");
      return;
    }

    setLoading(true);
    const url = editingId
      ? "/api/v1/permission/update"
      : "/api/v1/permission/create";
    const method = editingId ? "PUT" : "POST";

    try {
      const res = await authFetch(url, {
        method,
        // headers: {
        //   "Content-Type": "application/json",
        //   Authorization: `Bearer ${localStorage.getItem("token")}`,
        // },
        body: JSON.stringify({ ...permissionForm, id: editingId }),
      });

      const data = await res.json();
      if (!res.ok) throw new Error(data.detail || "Something went wrong");

      showToast(editingId ? "Permission updated" : "Permission created", editingId ? "info" : "success");

      setPermissionForm({ name: "", slug: "", type: "" });
      setEditingId(null);
      fetchPermissions();
      document.querySelector("#permissionModal .btn-close").click();
    } catch (err) {
      showToast(err.message, "error");
    } finally {
      setLoading(false);
    }
  };

  const handleEdit = (perm) => {
    setPermissionForm({ name: perm.name, slug: perm.slug, type: perm.type });
    setEditingId(perm.id);
  };

  const handleDelete = async (id) => {
    if (!window.confirm("Are you sure you want to delete this permission?")) return;

    try {
      const res = await authFetch(`/api/v1/permission/delete/${id}`, {
        method: "DELETE",
        // headers: {
        //   Authorization: `Bearer ${localStorage.getItem("token")}`,
        // },
      });

      const data = await res.json();
      if (!res.ok) throw new Error(data.detail || "Delete failed");

      showToast("Permission deleted", "error");
      fetchPermissions();
    } catch (err) {
      showToast(err.message, "error");
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setPermissionForm({ ...permissionForm, [name]: value });
  };

  useEffect(() => {
      if (permissions.length === 0) return;
    
      const $ = window.$;
      const interval = setInterval(() => {
        const table = $("#example2");
        if (!table.length || !$.fn.DataTable) return;
    
        try {
          if ($.fn.DataTable.isDataTable(table)) {
            table.DataTable().destroy();
          }
    
          const dt = table.DataTable({
            lengthChange: false,
            pageLength: 10,
            // buttons: ["copy", "excel", "pdf", "print", "colvis"],
            order: [[0, "desc"]], // disable initial ordering
          });
    
          dt.buttons().container().appendTo("#example2_wrapper .col-md-6:eq(0)");
          clearInterval(interval);
        } catch (err) {
          console.error("DataTable init error:", err);
        }
      }, 100);
    
      return () => clearInterval(interval);
    }, [permissions]);

  return (
    <div className="page-wrapper">
      <div className="page-content-wrapper">
        <div className="page-content">
          <div className="card">
            <div className="card-body">
              <div className="card-title d-flex justify-content-between align-items-center">
                <h4 className="mb-0">Permission Manager</h4>
                <button
                  className="btn btn-primary"
                  data-bs-toggle="modal"
                  data-bs-target="#permissionModal"
                  onClick={() => {
                    setPermissionForm({ name: "", slug: "", type: "" });
                    setEditingId(null);
                  }}
                >
                  Add
                </button>
              </div>

              {/* Modal */}
              <div className="modal fade" id="permissionModal" tabIndex="-1" aria-hidden="true">
                <div className="modal-dialog">
                  <div className="modal-content">
                    <div className="modal-header">
                      <h5 className="modal-title">{editingId ? "Edit Permission" : "Add Permission"}</h5>
                      <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div className="modal-body">
                      <label class="form-label"> Name</label>
                      <input
                        name="name"
                        placeholder="Permission Name"
                        className="form-control mb-2"
                        value={permissionForm.name}
                        onChange={handleChange}
                      />
                       <label class="form-label"> Slug</label>
                      <input
                        name="slug"
                        placeholder="Slug"
                        className="form-control mb-2"
                        value={permissionForm.slug}
                        onChange={handleChange}
                      />
                       <label class="form-label"> Type</label>
                      <input
                        name="type"
                        placeholder="Type"
                        className="form-control mb-2"
                        value={permissionForm.type}
                        onChange={handleChange}
                      />
                    </div>
                    <div className="modal-footer">
                      <button className="btn btn-secondary" data-bs-dismiss="modal">Close</button>
                      <button className="btn btn-primary" onClick={handleCreateOrUpdate} disabled={loading}>
                        {loading ? "Saving..." : editingId ? "Update" : "Save"}
                      </button>
                    </div>
                  </div>
                </div>
              </div>

              {/* Table */}
              <hr />
              <div className="table-responsive">
                <table id="example2" className="table table-striped table-bordered">
                  <thead>
                    <tr>
                      <th>Name</th>
                      <th>Slug</th>
                      <th>Type</th>
                      <th>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {permissions.length === 0 && (
                      <tr>
                        <td colSpan="4" className="text-center">No Permissions found</td>
                      </tr>
                    )}
                    {permissions.map((perm) => (
                      <tr key={perm.id}>
                        <td>{perm.name}</td>
                        <td>{perm.slug}</td>
                        <td>{perm.type}</td>
                        <td>
                          <button
                            className="btn btn-sm btn-info me-2"
                            data-bs-toggle="modal"
                            data-bs-target="#permissionModal"
                            onClick={() => handleEdit(perm)}
                          >
                            <span class="bx bx-edit"></span>
                          </button>
                          {/* <button className="btn btn-sm btn-danger" onClick={() => handleDelete(perm.id)}>
                            <span class="bx bx-trash"></span>
                          </button> */}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Permission;
